var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mr-5 searchHolder",staticStyle:{"width":"100%"}},[_c('h2',{staticClass:"pl-3 mt-md-2 wide pt-2 ml-lg-3 mr-lg-3"},[_vm._v("Search Results")]),_c('div',{ref:"searchContainer",staticClass:"ml-lg-3 mr-lg-3"})])])}
var staticRenderFns = []

export { render, staticRenderFns }